(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2239],{

/***/ 9011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ o; },
/* harmony export */   "h": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var _utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53586);
var o=(e=>(e.mobile="mobile",e.desktop="desktop",e))(o||{});function t(){let e=!1;return function(i){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(i)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(i.substr(0,4)))&&(e=!0)}(navigator.userAgent||navigator.vendor||window.opera),e}const m=_utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z&&t()?"mobile":"desktop";function n(){return m}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 35040:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practical-informations/[...uid]",
      function () {
        return __webpack_require__(20801);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13200);






function WrapperWithLink(_param) {
    var className = _param.className, children = _param.children, href = _param.href, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "href"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, rest), {
            className: className,
            children: children
        })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: children
        })
    });
}
WrapperWithLink.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (WrapperWithLink);


/***/ }),

/***/ 97839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51526);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57891);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51025);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69235);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
function ImageHover(_param) {
    var className = _param.className, isHovering = _param.isHovering, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "isHovering"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isImageHoverLoaded = ref[0], setIsImageHoverLoaded = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .AnimatePresence */ .M, {
        children: isHovering && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_7__.m.div, {
            className: cx(className),
            initial: {
                opacity: 0
            },
            animate: isImageHoverLoaded ? {
                opacity: 1,
                transition: {
                    duration: 0.25
                }
            } : {},
            exit: {
                opacity: 0,
                transition: {
                    duration: 0.25
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                onLoadingComplete: function() {
                    setIsImageHoverLoaded(true);
                }
            }, rest))
        })
    });
}
ImageHover.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (ImageHover);


/***/ }),

/***/ 72206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ CARD_IMAGE_LOADER; },
/* harmony export */   "u": function() { return /* binding */ CARD_PRODUCT_LAYOUT; }
/* harmony export */ });
var CARD_PRODUCT_LAYOUT = {
    REGULAR: "regular",
    SMALL_GRID: "small_grid",
    MEDIUM_GRID: "medium_grid",
    BIG_GRID: "big_grid",
    SEARCH_GRID: "search_grid"
};
var CARD_IMAGE_LOADER = {
    STORYBLOK: "storyblok",
    SHOPIFY: "shopify"
};


/***/ }),

/***/ 20801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ CustomerInformations; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/components/PageViewAnalytics/index.tsx
var PageViewAnalytics = __webpack_require__(68971);
// EXTERNAL MODULE: ./src/components/Slices/PushGeneric/index.tsx + 1 modules
var PushGeneric = __webpack_require__(70544);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/components/Navigation/SideNavigation/styles.module.scss
var styles_module = __webpack_require__(32802);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Navigation/SideNavigation/index.tsx









var cx = bind_default().bind((styles_module_default()));
function SideNavigation(param) {
    var className = param.className, links = param.links, sliceIndex = param.sliceIndex;
    var customSliderRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).SideNavigation, className),
        ref: customSliderRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx((styles_module_default()).container, (styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).hideOnSmallScreen),
                children: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
                    var Tag = sliceIndex === 0 && (link === null || link === void 0 ? void 0 : link.active) ? "h1" : "span";
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                        className: cx((styles_module_default()).link, {
                            active: link === null || link === void 0 ? void 0 : link.active
                        }),
                        lineProps: {
                            initialLineState: "none"
                        }
                    }, link), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                            children: link === null || link === void 0 ? void 0 : link.children
                        })
                    }), "side_nav_item_".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                className: cx((styles_module_default()).slider, (styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).hideOnLargeScreen),
                snap: true,
                customSliderRef: customSliderRef,
                children: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                        className: cx((styles_module_default()).link, {
                            active: link === null || link === void 0 ? void 0 : link.active
                        }),
                        lineProps: {
                            initialLineState: "none"
                        }
                    }, link), "side_nav_mobile_item_".concat(index));
                })
            })
        ]
    });
}
SideNavigation.defaultProps = {};
/* harmony default export */ var Navigation_SideNavigation = (SideNavigation);

// EXTERNAL MODULE: ./src/components/UI/TwoColumnsLayout/index.tsx + 5 modules
var TwoColumnsLayout = __webpack_require__(61281);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/SideNavTwoColumnsContent/styles.module.scss
var SideNavTwoColumnsContent_styles_module = __webpack_require__(24629);
var SideNavTwoColumnsContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(SideNavTwoColumnsContent_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/SideNavTwoColumnsContent/index.tsx







var SideNavTwoColumnsContent_cx = bind_default().bind((SideNavTwoColumnsContent_styles_module_default()));
function SideNavTwoColumnsContent(param) {
    var className = param.className, mainNavigation = param.mainNavigation, rows = param.rows, title = param.title, index = param.index;
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title24SangBleuLight */.C.Title24SangBleuLight
    });
    var leftColumn = [
        (mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation_SideNavigation, {
            className: SideNavTwoColumnsContent_cx((SideNavTwoColumnsContent_styles_module_default()).sideNavigation),
            links: mainNavigation,
            sliceIndex: index
        }, "left_column_item") : title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            className: SideNavTwoColumnsContent_cx((SideNavTwoColumnsContent_styles_module_default()).title, titleStyle),
            children: title
        }, "left_column_item") : null, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: SideNavTwoColumnsContent_cx((SideNavTwoColumnsContent_styles_module_default()).SideNavTwoColumnsContent, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoColumnsLayout/* default */.Z, {
            leftColumnComponents: leftColumn,
            rightColumnComponents: rows,
            layout: TwoColumnsLayout/* TwoColumnsLayoutsTypes.THIRDS */.b.THIRDS
        })
    });
}
SideNavTwoColumnsContent.defaultProps = {};
/* harmony default export */ var UI_SideNavTwoColumnsContent = (SideNavTwoColumnsContent);

// EXTERNAL MODULE: ./src/pages/practical-informations/styles.module.scss
var practical_informations_styles_module = __webpack_require__(466);
var practical_informations_styles_module_default = /*#__PURE__*/__webpack_require__.n(practical_informations_styles_module);
;// CONCATENATED MODULE: ./src/pages/practical-informations/[...uid].tsx









var _uid_cx = bind_default().bind((practical_informations_styles_module_default()));
var __N_SSG = true;
function CustomerInformations(_param) {
    var additionalPush = _param.additionalPush, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "additionalPush"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: _uid_cx((practical_informations_styles_module_default()).CustomerfInformations),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_SideNavTwoColumnsContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                index: 0
            })),
            additionalPush && /*#__PURE__*/ (0,jsx_runtime.jsx)(PushGeneric/* default */.Z, (0,_object_spread/* default */.Z)({
                className: _uid_cx((practical_informations_styles_module_default()).additionalPush)
            }, additionalPush)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViewAnalytics/* PageViewAnalytics */.W, {
                template: "policy"
            })
        ]
    });
}


/***/ }),

/***/ 32802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SideNavigation":"styles_SideNavigation__c1Od5","hideOnSmallScreen":"styles_hideOnSmallScreen__ayrAa","hideOnLargeScreen":"styles_hideOnLargeScreen__MoR6J","container":"styles_container__9EZgr","link":"styles_link__FT31G","active":"styles_active__kOnWG"};

/***/ }),

/***/ 69235:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 24629:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CustomerfInformations":"styles_CustomerfInformations__Iti_o","additionalPush":"styles_additionalPush__Sp3VM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,3310,4213,2873,5750,1281,9774,2888,179], function() { return __webpack_exec__(35040); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);